import styled, { keyframes } from 'styled-components'

const animation = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
`

export const RecordingIcon = styled.div`
    --size: 8px;

    width: var(--size);
    height: var(--size);
    background-color: ${(p) => p.theme.colors.primaryRed};
    border-radius: 50%;
    animation-name: ${animation};
    animation-duration: 2s;
    animation-iteration-count: infinite;
`
